export enum DwnInterfaceName {
  Messages = 'Messages',
  Protocols = 'Protocols',
  Records = 'Records'
}

export enum DwnMethodName {
  Configure = 'Configure',
  Query = 'Query',
  Read = 'Read',
  Write = 'Write',
  Delete = 'Delete',
  Subscribe = 'Subscribe'
}
